import { FC, useState } from "react";
import { CommonInputControlsProps } from "./types";
import { StateAction } from "../../../helpers/functions/types";
import { NAMED_NARROW_INPUT_STYLES, NAMED_WRAPPER_STYLES } from "./constants";
import { LabelAtom } from "./atoms/LabelAtom";
import { Disabled } from "../../../components/Disabled";
import { INPUT_DEFAULT_STYLES } from "../detailedPages/styles";

type NamedTimeProps = CommonInputControlsProps<string, StateAction<string>>;
export const NamedTime: FC<NamedTimeProps> = ({
  title,
  customId,
  value,
  onChange,
  disabled,
  styleVariant = "slideOver",
  permissions,
  required,
}) => {
  const timeId = customId ?? `${title}TimeInput`;
  const [time, setTime] = useState(value);

  const TimeNode = (
    <input
      name={timeId}
      id={timeId}
      type="time"
      value={time}
      onChange={(e) => {
        const newTime = e.target.value;
        setTime(newTime);
        onChange?.(newTime);
      }}
      className={`max-w-[50%] py-2 ${INPUT_DEFAULT_STYLES}`}
      disabled={disabled}
      required={required}
    />
  );
  return (
    <div className="px-4" onClick={(e) => e.stopPropagation()}>
      <div
        className={`${NAMED_WRAPPER_STYLES} ${NAMED_NARROW_INPUT_STYLES[styleVariant]}`}
      >
        <LabelAtom
          title={title}
          htmlFor={timeId}
          srOnly={styleVariant === "srLabel"}
        />
        {(onChange || customId) &&
          (permissions ? (
            <Disabled editPermissions={permissions}>{TimeNode}</Disabled>
          ) : (
            TimeNode
          ))}
      </div>
    </div>
  );
};
